import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestMovies from './components/LatestMovies';
import FeaturedSection from './components/FeaturedSection';
import useSEO from '@/hooks/useSEO';

export default function Home() {
  useSEO({
    title: '人人影院：免费高清在线观看，最新电影电视剧不缓冲追剧，海量影视全集每日更新',
    description: '人人影院提供免费高清在线观看服务，涵盖最新电影、电视剧全集，无需缓冲流畅播放，海量资源每日更新，追剧看片一站解决。',
    keywords: '人人影院,高清免费在线观看,最新电影,电视剧全集,不缓冲,在线观看,免费影视,每日更新,追剧,流畅播放',
    canonicalUrl: 'https://renrencinema.com/',
    ogTitle: '人人影院：免费高清在线观看，最新电影电视剧不缓冲追剧',
    ogDescription: '人人影院提供免费高清在线观看服务，涵盖最新电影、电视剧全集，无需缓冲流畅播放，海量资源每日更新，追剧看片一站解决。',
    ogUrl: 'https://renrencinema.com/',
    structuredData: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "人人影院",
        "url": "https://renrencinema.com/",
        "description": "人人影院提供免费高清在线观看服务，涵盖最新电影、电视剧全集，无需缓冲流畅播放，海量资源每日更新，追剧看片一站解决。",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://renrencinema.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "人人影院",
        "url": "https://renrencinema.com/",
        "description": "免费高清在线影视平台",
        "foundingDate": "2018"
      }
    ],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <LatestMovies />
        <FeaturedSection />

        <section className="w-full px-4 md:px-6 py-12 md:py-14 bg-primary-500">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-xl md:text-3xl font-bold text-background-50 font-heading mb-3">
              还在等什么？立即开始观影吧！
            </h2>
            <p className="text-sm text-background-50/80 max-w-md mx-auto mb-6">
              免费、高清、无广告，海量影视资源等你来发现
            </p>
            <a
              href="/category/dianying"
              className="inline-flex items-center gap-2 bg-background-50 text-primary-600 px-8 py-3 rounded-full text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all duration-200"
            >
              <span className="w-4 h-4 inline-flex items-center justify-center">
                <i className="ri-play-circle-fill text-base"></i>
              </span>
              开始免费观影
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}